import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { ConsumersService } from '../consumers.service';
import { CurrencyPipe, formatDate } from '@angular/common';
import * as moment from 'moment';
import { JwtHelperService } from "@auth0/angular-jwt";
import { AdminViewService } from 'src/app/framework/services/admin-view.service';
const helper = new JwtHelperService();

@Component({
  selector: 'app-all-consumers',
  templateUrl: './all-consumers.component.html',
  styleUrls: ['./all-consumers.component.scss'],
  providers: [CurrencyPipe]

})
export class AllConsumersComponent extends FeaturesBaseComponent implements OnInit {
  rowSelection: string;
  rowData: any[];
  columnDefs: any[];
  searchValue: any;
  showUpdateUser: boolean = true;
  selectedRows: any;
  private gridApi;
  private gridColumnApi;
  showUpdateRetailer: boolean;
  userRole: string = "";
  isButtonDisabled:boolean

  constructor(private router: Router, private consumersService: ConsumersService, private currencyPipe: CurrencyPipe, private adminViewServices:AdminViewService) {
    super();
    const token: string = localStorage.getItem('accessToken');
    let decoded_token: any = helper.decodeToken(token);
    this.userRole = decoded_token.role;
    
  }

  ngOnInit(): void {
    super.ngOnInit()
    this.initGrid()
       this.adminViewServices.checkAdminVRole().subscribe((res) => {
      this.isButtonDisabled = res

    })
  }
  initGrid() {
    this.consumersService.getAllConsumers().subscribe(
      res => {
        if (res['httpcode'] != 200) {
          return
        }
        this.rowData = res['data'];
      }
    );
    this.rowSelection = 'single',

      this.columnDefs = [
        { field: 'null', headerName: 'Action', width: 130, checkboxSelection: true },
        { field: 'mobileNumber', headerName: 'Mobile', width: 200,
          cellRenderer: (data) => {
            let formatNumber = data.value.slice(1)
            return  formatNumber;
          },
        },
        { field: 'userId', headerName: 'userId', width: 120, hide: true, sort: 'dsc' },
        { field: 'firstName', headerName: 'First Name', width: 200 },
        { field: 'lastName', headerName: 'Last Name', width: 200 },
        { field: 'emailId', headerName: 'Email Id', width: 200},
        { field: 'userStatus', headerName: 'Status', width: 180},
        { field: 'totalLoyaltyPoints', headerName: 'Total Loyalty Points', width: 200},
        { field: 'enrollTilaRewardsStatus', headerName: 'Rewards Status', width: 190,
             cellRenderer: (data)=> {
                if(data?.data?.enrollTilaRewardsStatus === 'Yes') {
                    return 'Enrolled';
                } else {
                    return 'Not Enrolled';
                }
            }},   
        { field: 'enrollTilaRewardsStatusUpdateDate', headerName: 'Status Update Date', width: 250, cellRenderer: (data) => {if(data.value){ return moment(data.value).format('MM/DD/YYYY hh:mm:ss:a');} }},
        { field: 'enrollPromotionalText', headerName: 'Text Status', width: 170,
            cellRenderer: (data) => {
                if(data?.data?.enrollPromotionalText === 'Yes') {
                    return 'Enrolled';
                } else {
                    return 'Not Enrolled';
                }
            }
        },
        { field: 'enrollPromotionalTextUpdateBy', headerName: 'Text Update By', width: 170},
        { field: 'enrollPromotionalTextUpdateDate', headerName: 'Text Update Date', width: 250, cellRenderer: (data) => { if(data.value){return moment(data.value).format('MM/DD/YYYY hh:mm:ss:a');}}},
        { field: 'enrollPromotionalEmail', headerName: 'Email Status', width: 170,
            cellRenderer: (data) => {
                if(data?.data?.enrollPromotionalEmail === 'Yes') {
                    return 'Enrolled';
                } else {
                    return 'Not Enrolled';
                }
            }
        },
        { field: 'enrollPromotionalEmailUpdateBy', headerName: 'Email Update By', width: 210},
        { field: 'enrollPromotionalEmailUpdateDate', headerName: 'Email Update Date', width: 250, cellRenderer: (data) => { if(data.value){return moment(data.value).format('MM/DD/YYYY hh:mm:ss:a');}}},
        { field: 'consumerSince', headerName: 'Customer Since', width: 200, cellRenderer: (data) => {if(data.value){ return moment(data.value).format('MM/DD/YYYY');}}}
      ]
      // if (this.userRole === 'Sales Rep' || this.userRole === 'Distributor') {
      //   this.columnDefs.splice(10, 0,
      //     { field: 'priceList', headerName: ' Commission Plan', width: 190 },
      //   )
      // }
  }
  exportData() {
    let header = this.columnDefs.map(columnDef => {
      let headerName = columnDef.headerName;
      return headerName;
      });
      let params: any = {
      fileName: 'Consumers.csv',
      //columnSeparator: ';',
      skipHeader: true,
      columnKeys: this.columnDefs.map(c => c.field || c.colId).filter(c => !!c)
      };
      params.customHeader = header.join(params.columnSeparator);
      params.processCellCallback = (cellParams) => {
      //
      if(cellParams && cellParams.column.colId === '') {
        return ''; //apply your timestamp formatter
      }else if(cellParams && cellParams.column.colId === 'accountCreatedDate') {
        return moment(cellParams.value).format('MM/DD/YYYY'); //apply your timestamp formatter
      }
      else if(cellParams && cellParams.column.colId === 'consumerSince') {
        return moment(cellParams.value).format('MM/DD/YYYY'); //apply your timestamp formatter
      }
      else if(cellParams && cellParams.column.colId === 'enrollTilaRewardsStatusUpdateDate' && cellParams.value != null)
      {
        return moment(cellParams.value).format('MM/DD/YYYY hh:mm:ss:a')
      }
      else if(cellParams && cellParams.column.colId === 'enrollPromotionalEmailUpdateDate' && cellParams.value != null)
      {
          return moment(cellParams.value).format('MM/DD/YYYY hh:mm:ss:a')
      }
      else if(cellParams && cellParams.column.colId === 'enrollPromotionalTextUpdateDate' && cellParams.value != null)
      {
          return moment(cellParams.value).format('MM/DD/YYYY hh:mm:ss:a')
      }
      else if(cellParams && cellParams.column.colId === 'enrollTilaRewardsStatus' && cellParams.value != null)
        {
            if(cellParams.value === 'Yes'){
              return 'Enrolled';
          } else {
              return 'Not Enrolled';
          }
        }
        else if(cellParams && cellParams.column.colId === 'enrollPromotionalText' && cellParams.value != null)
          {
              if(cellParams.value === 'Yes'){
                return 'Enrolled';
            } else {
                return 'Not Enrolled';
            }
          }
          else if(cellParams && cellParams.column.colId === 'enrollPromotionalEmail' && cellParams.value != null)
            {
                if(cellParams.value === 'Yes'){
                  return 'Enrolled';
              } else {
                  return 'Not Enrolled';
              }
            }
            else if (cellParams && cellParams.column.colId === "mobileNumber") {
              const formatted = `'${this.formatMobileNumber(cellParams.value)}'`;
              return formatted;
            }
        else return cellParams.value // no formatting
      }
      this.gridApi.exportDataAsCsv(params);
  }
  quickSearch() {
    this.gridApi.setQuickFilter(this.searchValue);
  }


  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    // setTimeout(() => { params.api.sizeColumnsToFit() }, 50);
  }
  onSelectionChanged(e) {

    this.selectedRows = this.gridApi.getSelectedRows();
    if (this.selectedRows && this.selectedRows != [] && this.selectedRows.length > 0 && this.selectedRows[0].role != 'Retailer') {
      this.showUpdateUser = false;
      return
    }
    this.showUpdateUser = true;
  }

  updateUser() {
    let userId = this.selectedRows[0].userId;
      this.router.navigate([`/features/consumers/manage-consumers/${userId}/edit-consumer/${userId}`])
  }
  ngOnDestroy() {
    super.ngOnDestroy()

  }

  formatMobileNumber(params: any): string {
    const phoneNumber = params;
    if (!phoneNumber) {
      return "";
    }

    if (phoneNumber.startsWith("+1")) {
      return phoneNumber.substring(2);
    }

    // Format mobile number (e.g., (123) 456-7890)
    const formatted = phoneNumber.replace(/\D/g, "");
    return formatted;
  }


}
